export default __webpack_public_path__ + "react/static/icons-c849f68af1db21685bfa9224dc810bb2.svg";